import * as React from "react"
import { AlertTriangle } from "lucide-react"
import { Button } from "@/components/ui/button"

interface State {
    error: Error | null
    key: number
}

/**
 * Локальный ErrorBoundary вокруг VisitCardBottomPanel: ловит любой крах
 * внутри карточки чтобы он не валил всю страницу `recsys`. Падает в
 * приглушённую плашку с короткой подсказкой; полный stack — в console.
 */
export class VisitCardErrorBoundary extends React.Component<
    { children: React.ReactNode },
    State
> {
    state: State = { error: null, key: 0 }

    static getDerivedStateFromError(error: Error): Partial<State> {
        return { error }
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error("[VisitCard] crash", error, info)
    }

    handleReset = () => {
        this.setState((s) => ({ error: null, key: s.key + 1 }))
    }

    render() {
        if (this.state.error) {
            return (
                <div className="flex h-10 shrink-0 items-center gap-2 rounded-l border border-state-warning bg-state-warning/10 px-3">
                    <AlertTriangle className="size-4 text-state-warning" strokeWidth={2} />
                    <span className="text-caption text-state-warning truncate">
                        Карточка обращения упала: {this.state.error.message}
                    </span>
                    <div className="ml-auto flex shrink-0 items-center gap-2">
                        <Button
                            type="button"
                            variant="ghost"
                            size="xs"
                            onClick={this.handleReset}
                            className="h-auto p-0 text-caption underline text-state-warning hover:bg-transparent hover:text-state-warning/80"
                        >
                            Перезагрузить
                        </Button>
                    </div>
                </div>
            )
        }
        return <React.Fragment key={this.state.key}>{this.props.children}</React.Fragment>
    }
}
